import { render } from "./ProfilePopup.vue?vue&type=template&id=2d69e775&scoped=true"
import script from "./ProfilePopup.vue?vue&type=script&lang=js"
export * from "./ProfilePopup.vue?vue&type=script&lang=js"

import "./ProfilePopup.vue?vue&type=style&index=0&id=2d69e775&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d69e775"]])

export default __exports__